import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  paper: {
    height: 700,
    maxHeight: 700
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    justifyContent: 'center'
  },
  crop: {
    height: 600
  },
  ratios: {
    display: 'flex',
    gap: 16,
    justifyContent: 'center'
  },
  cropContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  error: {
    color: theme.palette.error.main
  }
}));
